import moment from "moment";
import "moment/locale/vi";
import numeral from "numeral";

const dateTimeComparator = (dateFormat = "") => (a, b) => {
  if (!a && !b) {
    return 0;
  } else if (!b) {
    return 1;
  } else if (!a) {
    return -1;
  }
  const dateA = moment(a, dateFormat);
  const dateB = moment(b, dateFormat);
  if (dateA > dateB) {
    return 1;
  }
  if (dateA < dateB) {
    return -1;
  }
  return 0;
};

export function roundToN(num, n) {
  return +(Math.round(num + "e+" + n) + "e-" + n);
}

export const convertToLocalDate = (value) => {
  return moment(value).format("DD.MM.YYYY");
};

const convertToLocalFormat = (value, decimals = 3) => {
  registerGermanNumeral();
  if (value == null || isNaN(value)) {
    return "";
  }
  return numeral(roundToN(value, decimals)).format(
    "0,0." + "0".repeat(decimals)
  );
};

export function registerGermanNumeral() {
  if (!numeral.locales["vi"]) {
    numeral.register("locale", "vi", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      currency: {
        symbol: "đ"
      }
    });
  }

  numeral.locale("vi");
}

export { dateTimeComparator, convertToLocalFormat };

export function dateSortMethod(a, b) {
  return Date.parse(a) - Date.parse(b);
}


export const addSeparator = (rows, instrumentComparator) => {
  let newRows = [];
  rows.forEach((item) => {
    if (
      newRows.length > 0 &&
      instrumentComparator(newRows[newRows.length - 1], item)
    ) {
      newRows.push({ type: "separator" });
    }
    newRows.push(item);
  });
  return newRows;
};

export const validateEmail = (email) => {
  var re = /[^\s@]+@[^\s@]+\.[^\s@]+/;
  return re.test(String(email).toLowerCase());
};


